import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import DataProvider from "./redux/store";
import ScrollToTop from "./components/ScrollToTop";
import ReactGA from "react-ga4";
import { HelmetProvider } from "react-helmet-async";
import GAListener from "./RouteChangeTracker";
import { CookiesProvider } from "react-cookie";

const root = ReactDOM.createRoot(document.getElementById("root"));

ReactGA.initialize("G-780N0ENN8J");

root.render(
  <BrowserRouter>
    <DataProvider>
      <CookiesProvider>
        <ScrollToTop />
        <HelmetProvider>
          <App />
          <GAListener />
        </HelmetProvider>
      </CookiesProvider>
    </DataProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
